import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { openContactForm } from "@/lib/contactForm";
import { guideHeadings, slugifyHeading } from "@/lib/guideHub";
import { loadPreviewGuide } from "@/pages/designPreview/previewData";
import { PreviewCta } from "@/pages/designPreview/PreviewBits";
import { Reveal } from "@/pages/designPreview/previewMotion";
import { ReadingProgress, SceneIndex } from "@/pages/designPreview/PreviewVisuals";
import { categoryHue } from "@/pages/designPreview/previewTheme";

function Body({ blocks }) {
  return (
    <div className="dp-body">
      {(blocks || []).map((block, index) => {
        if (block.type === "h2") return <h2 id={slugifyHeading(block.text)} key={index}>{block.text}</h2>;
        if (block.type === "h3") return <h3 id={slugifyHeading(block.text)} key={index}>{block.text}</h3>;
        if (block.type === "ul" || block.type === "ol") {
          return (
            <ul className="dp-check" key={index}>
              {(block.items || []).map((item) => (
                <li key={item}><i /><span>{item}</span></li>
              ))}
            </ul>
          );
        }
        return <p key={index}>{block.text}</p>;
      })}
    </div>
  );
}

export default function GuideDetailPreview() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const resolved = slug || "homepage-agency-criteria";

  useEffect(() => {
    loadPreviewGuide(resolved).then(setData).catch(() => setData(null));
  }, [resolved]);

  const item = data?.item;
  const headings = guideHeadings(item?.body_blocks);
  const related = data?.related || [];
  const hue = categoryHue(item?.category);

  if (!item) {
    return <section className="dp-scene"><p>가이드를 불러오는 중입니다.</p></section>;
  }

  return (
    <div style={{ "--dp-node-hue": hue }}>
      <ReadingProgress />
      <section className="dp-scene">
        <div className="dp-gridbg" />
        <SceneIndex n={1} />
        <div className="dp-detail-hero">
          <Reveal>
            <p className="dp-kicker">GUIDE</p>
            <p className="dp-nav-text" style={{ padding: 0 }}>
              <Link to="/design-preview/guides"><span className="dp-nav-text__dot" />← Library</Link>
            </p>
            <h1 className="dp-display">{item.title}</h1>
          </Reveal>
          <div className="dp-question-panel">
            <span className="dp-question-panel__mark" aria-hidden="true">Q</span>
            {item.question ? <p className="dp-quote">{item.question}</p> : null}
          </div>
        </div>
      </section>

      {item.answer ? (
        <section className="dp-scene dp-scene--tight">
          <SceneIndex n={2} />
          <p className="dp-kicker">Answer</p>
          <blockquote className="dp-quote">{item.answer}</blockquote>
        </section>
      ) : null}

      <div className="dp-detail-grid">
        <article>
          <Body blocks={item.body_blocks} />
          <PreviewCta onClick={openContactForm}>{item.cta_label || "상담 신청"}</PreviewCta>
        </article>
        {headings.length > 1 ? (
          <nav className="dp-toc" aria-label="목차">
            {headings.map((row) => (
              <a key={row.id} href={`#${row.id}`}><span className="dp-toc__dot" />{row.text}</a>
            ))}
          </nav>
        ) : null}
      </div>

      {related.length ? (
        <div className="dp-track">
          {related.slice(0, 8).map((row) => (
            <Link key={row.href} to={row.href}>
              <span>Related</span>
              <strong>{row.label}</strong>
            </Link>
          ))}
        </div>
      ) : null}
    </div>
  );
}
